// Represent the layout once the user is logged in
import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import { Route, Switch } from "react-router-dom";
import Loader from "react-loader";

import "./uploaderLayout.css";
import { baseUrlRouter } from "../../utils/config";
import { checkUserLoggedIn } from "../../utils/routerUtils";

import NotFound from "../views/NotFound";
import { baseAppRouter } from "../../utils/config";

import PdfCaroussel from "../views/utils/PdfCaroussel";
import { hidePdfFile } from "../../actions/pdfActions";
import store from "../../store";

import asyncComponent from "../AsyncComponent";
const AsyncRunningTasksContainer = asyncComponent(() =>
	import("../container/RunningTasksContainer")
);
const AsyncCommandContainer = asyncComponent(() =>
	import("../container/CommandContainer/CommandContainer")
);
const AsyncUploadFileContainer = asyncComponent(() =>
	import("../container/UploadFileContainer")
);
const AsyncConfigPretraitement = asyncComponent(() =>
	import("../container/ConfigPretraitementContainer")
);
const AsyncSettingsContainer = asyncComponent(() =>
	import("../container/pomui/SettingsContainer")
);

class UploaderLayout extends Component {
	componentDidMount() {
		checkUserLoggedIn(this.props);
	}
	componentWillUpdate(nextProps, nextState) {
		if (nextProps.goToLoginPage) {
			this.props.history.push(baseUrlRouter);
		}
	}
	// place to check for token on page change, redirect to login page if token unavailable
	componentDidUpdate() {
		store.dispatch(hidePdfFile());
		if (
			this.props.userToken &&
			!this.props.goToLoginPage &&
			this.props.logged
		)
			checkUserLoggedIn(this.props);
	}
	render() {
		return (
			<Loader loaded={this.props.logged}>
				<PdfCaroussel />
				<Col xs={12}>
					<Switch>
						<Route
							exact
							path={baseAppRouter + "runningTasks"}
							component={AsyncRunningTasksContainer}
						/>
						<Route
							path={
								baseAppRouter + "runningTasks/batch/:document"
							}
							component={AsyncCommandContainer}
						/>
						<Route
							path={baseAppRouter + "runningTasks/unique/:order"}
							component={AsyncCommandContainer}
						/>
						<Route
							path={baseAppRouter + "upload"}
							component={AsyncUploadFileContainer}
						/>
						<Route
							exact
							path={baseAppRouter + "configPretraitement"}
							component={AsyncConfigPretraitement}
						/>
						<Route
							path={baseAppRouter + "configPretraitement/:name"}
							component={AsyncSettingsContainer}
						/>
						<Route
							path={baseAppRouter + "*"}
							component={NotFound}
						/>
					</Switch>
				</Col>
			</Loader>
		);
	}
}

const mapStateToProps = function(store) {
	return {
		logged: store.loginState.logged,
		goToLoginPage: store.appState.goToLoginPage,
		userToken: store.userState.token
	};
};

UploaderLayout.propTypes = {
	logged: PropTypes.bool.isRequired
};

export default connect(mapStateToProps)(UploaderLayout);



// WEBPACK FOOTER //
// ./src/components/layouts/UploaderLayout.js